"use client";

import { devLabel } from "@/lib/dev-labels";

export type ModeKey = "url" | "file" | "script" | "multicam" | "batch";

const TABS: { key: ModeKey; label: string; iconPath: React.ReactNode }[] = [
	{
		key: "url",
		label: "YouTube URL",
		iconPath: (
			<g fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
				<circle cx="12" cy="12" r="10" />
				<line x1="2" y1="12" x2="22" y2="12" />
				<path d="M12 2a15 15 0 0 1 4 10 15 15 0 0 1-4 10 15 15 0 0 1-4-10 15 15 0 0 1 4-10z" />
			</g>
		),
	},
	{
		key: "file",
		label: "파일 업로드",
		iconPath: (
			<g fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
				<path d="M16 16l-4-4-4 4" />
				<line x1="12" y1="12" x2="12" y2="21" />
				<path d="M20.4 14.5A6 6 0 0 0 16 7H8a6 6 0 0 0-1.4 11.4" />
			</g>
		),
	},
	{
		key: "script",
		label: "스크립트",
		iconPath: (
			<g fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
				<path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
				<polyline points="14 2 14 8 20 8" />
				<line x1="16" y1="13" x2="8" y2="13" />
				<line x1="16" y1="17" x2="8" y2="17" />
			</g>
		),
	},
	{
		key: "multicam",
		label: "멀티캠",
		iconPath: (
			<g fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
				<rect x="2" y="6" width="14" height="12" rx="2" />
				<circle cx="9" cy="12" r="3" />
				<polygon points="18 8 22 6 22 18 18 16 18 8" />
			</g>
		),
	},
	{
		key: "batch",
		label: "멀티 batch",
		iconPath: (
			<g fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
				<line x1="3" y1="6" x2="21" y2="6" />
				<line x1="3" y1="12" x2="21" y2="12" />
				<line x1="3" y1="18" x2="21" y2="18" />
			</g>
		),
	},
];

export interface ModeTabsProps {
	active: ModeKey;
	onChange: (m: ModeKey) => void;
}

export function ModeTabs({ active, onChange }: ModeTabsProps) {
	return (
		<div
			role="tablist"
			aria-label="Create mode"
			style={{
				display: "flex",
				gap: 3,
				marginBottom: 10,
				padding: 3,
				background: "rgba(0,0,0,0.4)",
				borderRadius: 6,
				width: "fit-content",
			}}
			{...devLabel("11-A1")}
		>
			{TABS.map((t) => {
				const on = active === t.key;
				return (
					<button
						key={t.key}
						type="button"
						role="tab"
						aria-selected={on}
						data-mode={t.key}
						onClick={() => onChange(t.key)}
						style={{
							padding: "6px 14px",
							borderRadius: 5,
							fontSize: 11,
							fontWeight: 600,
							cursor: "pointer",
							color: on ? "#0a0a0a" : "#a3a3a3",
							background: on ? "#d4af37" : "transparent",
							border: "none",
							display: "inline-flex",
							alignItems: "center",
							gap: 5,
							transition: "all 0.15s",
						}}
					>
						<svg width="11" height="11" viewBox="0 0 24 24">
							{t.iconPath}
						</svg>
						{t.label}
						{t.key === "batch" && (
							<span
								style={{
									marginLeft: 2,
									fontSize: 8,
									padding: "0 4px",
									borderRadius: 3,
									background: "#d4af37",
									color: "#0a0a0a",
								}}
							>
								MML+
							</span>
						)}
					</button>
				);
			})}
		</div>
	);
}
